<template>
  <v-autocomplete
    v-model="selected"
    cache-items
    clearable
    chips
    item-text="name.es"
    label="Etiquetas:"
    multiple
    no-data-text="No hay etiquetas registradas"
    placeholder="Etiqueta"
    prepend-icon="mdi-feature-search"

    :items="items"
    :item-value="id ? 'id' : 'name.es'"
    :loading="loading"
    :search-input.sync="search"
    @click:clear="$emit('selected', [])"
  ></v-autocomplete>
</template>

<script>
import axios from "axios";
export default {
  name: "SearchTagsInput",
  props: ["id", "etiquetasActual"],
  data() {
    return {
      selected: [],
      items: [],
      loading: false,
      search: "",
    };
  },
  computed: {
    etiquetasFormat() {
        if(typeof this.etiquetasActual === "undefined"){
            return [];
        }
      return this.etiquetasActual.map((element) => {
        return this.id ? element.id : element.name.es;
      });
    },
  },
  mounted() {
    this.loadData();

    this.selected = this.etiquetasFormat;
  },
  watch: {
    search(val) {
      // Items have already been requested
      if (
        this.loading ||
        typeof val !== "string" ||
        (typeof val === "string" && val.length < 1)
      ) {
        return;
      }

      this.loadData();
    },
    selected(val) {
      if (val.length < 1) {
        return;
      }

      this.$emit("selected", this.selected);
    },
  },
  methods: {
    loadData() {
      this.loading = true;

      // Lazily load input items
      axios
        .get("/api/etiqueta/listar", {
          params: { is_list: 1, search: this.search },
        })
        .then(({ data }) => {
          this.items = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
</style>
